<form [formGroup]="form" (ngSubmit)="onSubmit($event)" id="signInForm" class="">
    <ng-container *ngIf="(twoFaEmailForm$ | async) || (twoFaOtpForm$ | async); else defaultSignInForm">
        <div class="form__group form__group--title">
            <div class="form__title">
                <svg-image name="appodeal-new-logo" class="header-logo"></svg-image>
                <page-title-content [title]="'signin.2faTitle' | i18next"></page-title-content>
            </div>
        </div>

        <div class="form__group" *ngIf="twoFaEmailForm$ | async">
            <label class="form__label txt-md" for="email">{{ 'signin.form.labels.twoFactorEmailCode' | i18next }}<sub>*</sub></label>
            <div class="form__control">
                <input
                    type="text"
                    id="twoFactorEmailCode"
                    formControlName="twoFactorEmailCode"
                    autoComplete="false"
                    class="input"
                    [tooltip]="'signin.form.labels.twoFactorEmailCodeHint' | i18next"
                />
            </div>
            <input-errors-tooltip [control]="form.get('twoFactorEmailCode')"></input-errors-tooltip>
        </div>

        <div class="form__group" *ngIf="twoFaOtpForm$ | async">
            <label class="form__label txt-md" for="email">{{ 'signin.form.labels.twoFactorOneTimePassword' | i18next }}<sub>*</sub></label>
            <div class="form__control">
                <input
                    type="text"
                    id="twoFactorOneTimePassword"
                    formControlName="twoFactorOneTimePassword"
                    autoComplete="false"
                    class="input"
                    [tooltip]="'signin.form.labels.twoFactorOneTimePasswordHint' | i18next"
                />
            </div>
            <input-errors [control]="form.get('twoFactorOneTimePassword') || errorMessage"></input-errors>
        </div>

        <div class="form__group">
            <div class="form__control form__control--actions">
                <button type="submit" class="button button--primary txt-md" [class.loading]="formService.pending$ | async">
                    {{ 'signin.form.2fa_submit_button' | i18next }}
                </button>
            </div>
        </div>
    </ng-container>

    <ng-template #defaultSignInForm>
        <div class="form__group form__group--title">
            <div class="form__title">
                <svg-image name="appodeal-new-logo" class="header-logo"></svg-image>
                <page-title-content [title]="'signin.title' | i18next"></page-title-content>
            </div>
            <form-errors [top]="false"></form-errors>
        </div>

        <div class="form__group">
            <label class="form__label txt-md" for="email">{{ 'signin.form.labels.email' | i18next }}<sub>*</sub></label>
            <div class="form__control">
                <input type="text" id="email" formControlName="email" autoComplete="false" class="input" />
            </div>
        </div>

        <div class="form__group">
            <label class="form__label txt-md" for="password">{{ 'signin.form.labels.password' | i18next }}<sub>*</sub></label>
            <div class="form__control">
                <password-input id="password" formControlName="password"></password-input>
            </div>
        </div>

        <div class="form__group">
            <div class="form__control form__control--actions">
                <button type="submit" class="button button--primary" [class.loading]="formService.pending$ | async">
                    {{ 'signin.form.submit_button' | i18next }}
                </button>

                <ng-container *ngIf="signInWithGoogle.isEnabled">
                    <a type="button" class="login-with-google-btn" [href]="signInWithGoogleUrl">
                        {{ 'signin.oauth.signInWithGoogle' | i18next }}
                    </a>
                </ng-container>
            </div>
        </div>

        <div class="form__group">
            <div class="form__control form__control--actions form__control--links">
                <div>
                    <a [href]="appUrls.SIGN_UP | appUrl" class="link" data-testid="signUpLink">
                        <span>{{ 'signin.links.signup' | i18next }}</span>
                    </a>
                </div>
                <div>
                    <a [routerLink]="appUrls.REMIND_PASSWORD | appUrl" class="link">{{ 'signin.links.remind_password' | i18next }}</a>
                </div>
            </div>
        </div>
    </ng-template>
</form>
